import { createVolumeAutocompleteFilter } from './common/createVolumeAutocompleteFilter';

export default createVolumeAutocompleteFilter({
  field: 'clusterName',
  groupLabel: 'Cluster',
  mustTypeFirstMessage: 'Start typing cluster name',
  defaultQuery: 'eks',
  tagVariant: 'cluster',
  logPrefix: '[ClusterFilter]',
});
